import Icon from '@ant-design/icons';
import { ReactComponent as SLIcon } from 'assets/images/icon/SmartLock_Icon.svg';
import { smallTimeOptions } from 'assets/styles/constants';
import WithHyperLink from 'library/hoc/withHyperLink';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Flex, Popover, Row, Space, Tooltip, Typography } from 'zui/Antd';
import RenderSiteName from '../RenderSiteName';
import AssetGroupCardWrapper, { QuickViewWrapper } from './styles';
import { ViewAssetGroupModal, AssetGroupActionsDropdown } from 'zComponents/molecules';

const { Paragraph, Title, Text } = Typography;

const AssetGroupCard = ({ group }) => {
	// HOC
	const SiteNameWithLink = WithHyperLink(RenderSiteName);

	// Local States
	const [viewModalVisible, setViewModalVisible] = useState(false);
	const [groupDevices, setGroupDevices] = useState([]);

	// Redux States
	const { data: devicesData } = useSelector((state) => state.Devices);
	const {
		remoteConfig: { constants }
	} = useSelector((state) => state.FbRemoteConfig);

	useEffect(() => {
		if (group.assets) {
			// find the devices that are in the group.assets is an array of uIDs
			const filteredDevices = devicesData.filter((item) => {
				// check if the group.asset array of object containers the uID of the item
				return group.assets.some((asset) => asset.assetID === item.uID);
			});

			setGroupDevices(filteredDevices);
		}

		return () => {
			setGroupDevices([]);
		};
	}, [devicesData, group.assets]);

	return (
		<AssetGroupCardWrapper
			title={
				<ViewAssetGroupModal
					data={{ groupID: group.groupID }}
					visible={viewModalVisible}
					setVisible={setViewModalVisible}
				>
					<Flex
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center'
						}}
					>
						<Title
							level={4}
							style={{
								margin: 0
							}}
							onClick={() => setViewModalVisible(true)}
						>
							{group.name}
						</Title>

						{group.typeID === constants.ACCESS_CONTROL && (
							<Tooltip title='Access Group'>
								<Icon style={{ fontSize: '25px' }} component={SLIcon} />
							</Tooltip>
						)}
					</Flex>
				</ViewAssetGroupModal>
			}
			actions={[AssetGroupActionsDropdown({ group })]}
		>
			<Row>
				<Col lg={24} md={24} sm={24} xs={24} className='groupInfoContainer'>
					<div className='subInfoContainer'>
						<div>
							<label className='infoLabel'>Type</label>
							<p className='infoProp'>{group.typeName}</p>
						</div>
						<div>
							<label className='infoLabel'>Site</label>
							<SiteNameWithLink dataID={group.siteID} type='site' />
						</div>
						<div>
							<label className='infoLabel'>Assets</label>
							<p className='infoProp'>{group.assets.length}</p>
						</div>
					</div>
					{group.description && (
						<div className='descContainer'>
							<Paragraph
								ellipsis={{ rows: 2, expandable: false, tooltip: group.description }}
								className='description'
							>
								{group.description}
							</Paragraph>
						</div>
					)}
				</Col>
			</Row>
			<Row>
				<Popover
					key={group.groupID}
					placement='right'
					trigger={['click']}
					color='white'
					overlayStyle={{
						width: '700px',
						zIndex: '999'
					}}
					overlayInnerStyle={{
						borderRadius: '4px',
						width: '100%'
					}}
					destroyTooltipOnHide
					title={
						<Text
							style={{
								fontSize: '14px',
								fontWeight: '600'
							}}
						>
							Assets in this group
						</Text>
					}
					content={() => (
						<QuickViewWrapper>
							<div className='cardContainer'>
								{groupDevices.map((item) => {
									return <item.cardComponent key={item.uID} device={item} />;
								})}
							</div>
						</QuickViewWrapper>
					)}
				>
					<Button className='viewAssetButton'>Quick View</Button>
				</Popover>
			</Row>
			<Row className='metaContainer'>
				<Space wrap className='dateContainer'>
					<p
						className='metaField'
						title={new Date(group.modifiedDate).toLocaleString('en-AU', smallTimeOptions)}
					>
						<span className='metaLabel'>Last updated: </span>
						{new Date(group.modifiedDate).toLocaleString('en-AU', smallTimeOptions)}
					</p>
					<p
						className='metaField'
						title={new Date(group.createdDate).toLocaleString('en-AU', smallTimeOptions)}
					>
						<span className='metaLabel'>Created on: </span>
						{new Date(group.createdDate).toLocaleString('en-AU', smallTimeOptions)}
					</p>
				</Space>
			</Row>
		</AssetGroupCardWrapper>
	);
};

export default AssetGroupCard;
